import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import { Button, Divider } from 'antd'
import { UserOutlined, LogoutOutlined } from '@ant-design/icons'
import { BottomSheet } from '@pushly/aqe/lib/components/bottom-sheet/bottom-sheet'
import { useAppState, useAuthService } from '../hooks/use-mobile-service'
import './profile-menu-sheet.scss'

interface ProfileMenuSheetProps {
    open: boolean
    onClose: () => void
}

export const ProfileMenuSheet: React.FC<ProfileMenuSheetProps> = observer(({ open, onClose }) => {
    const appState = useAppState()
    const authService = useAuthService()

    const user = appState.currentUser

    const handleLogout = useCallback(() => {
        onClose()
        authService.logout(false)
    }, [onClose, authService])

    return (
        <BottomSheet open={open} onClose={onClose} title="Account" height="auto">
            <div className="profile-menu-sheet">
                {/* User identity */}
                {user && (
                    <div className="profile-menu-sheet__user">
                        <div className="profile-menu-sheet__avatar">
                            <UserOutlined />
                        </div>
                        <div className="profile-menu-sheet__user-info">
                            <span className="profile-menu-sheet__name">{user.name}</span>
                            <span className="profile-menu-sheet__email">{user.email}</span>
                        </div>
                    </div>
                )}

                <Divider className="profile-menu-sheet__divider" />

                {/* Actions */}
                <div className="profile-menu-sheet__menu">
                    <Button
                        type="text"
                        icon={<LogoutOutlined />}
                        onClick={handleLogout}
                        danger
                        block
                        className="profile-menu-sheet__menu-item"
                    >
                        Logout
                    </Button>
                </div>
            </div>
        </BottomSheet>
    )
})

ProfileMenuSheet.displayName = 'ProfileMenuSheet'
